import { useEffect, useRef } from "react";
import usePersistentState from "./usePersistentState";

export const ADMIN_TAB_RESET_EVENT = "admincentral:menu-reset";

export default function usePersistentTabState(storageKey, defaultValue) {
  const [value, setValue] = usePersistentState(storageKey, defaultValue);
  const isReloadingRef = useRef(false);

  useEffect(() => {
    if (typeof window === "undefined") return undefined;

    const handleBeforeUnload = () => {
      isReloadingRef.current = true;
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      if (!isReloadingRef.current) {
        try {
          window.localStorage.removeItem(storageKey);
        } catch (_err) {
          // ignore storage errors
        }
      }
    };
  }, [storageKey]);

  useEffect(() => {
    if (typeof window === "undefined") return undefined;
    const handleMenuReset = () => {
      try {
        window.localStorage.removeItem(storageKey);
      } catch (_err) {
        // ignore storage errors
      }
      setValue(defaultValue);
    };
    window.addEventListener(ADMIN_TAB_RESET_EVENT, handleMenuReset);
    return () => {
      window.removeEventListener(ADMIN_TAB_RESET_EVENT, handleMenuReset);
    };
  }, [storageKey, defaultValue, setValue]);

  return [value, setValue];
}
